import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconShapeTriangle';
/** Renders an SVG icon. */
const SvgShapeTriangle = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M14.198 4.742c.727-1.509 2.876-1.509 3.603 0l9.818 20.39a2 2 0 0 1-1.665 2.863l-.137.005v-2L15.999 5.61 6.182 26v2a2 2 0 0 1-1.857-2.742l.055-.125zM25.817 26v2H6.182v-2z"
      />
    </svg>
  );
};
SvgShapeTriangle.displayName = displayName;
export default SvgShapeTriangle;
